import React from "react";
import Button from "../../components/ui/Button";
import RemoteTable from "../../components/ui/RemoteTable";
import { printFullDate } from "../../utils/time";
import { useLanguage } from "../../context/LanguageContext";

const HmResults = () => {
    const { language } = useLanguage();

    const content = {
        columns: {
            sequence: { en: "Sequence", ar: "التسلسل", de: "Sequenz" },
            homeworkName: { en: "Homework Name", ar: "اسم الواجب", de: "Hausaufgabenname" },
            questionCount: {
                en: "Number of Questions",
                ar: "عدد الاسئلة",
                de: "Anzahl der Fragen",
            },
            result: { en: "Result", ar: "النتيجة", de: "Ergebnis" },
            grade: { en: "Grade", ar: "الدرجة", de: "Note" },
            solvedQuestions: {
                en: "Solved Questions",
                ar: "عدد الاسئلة المحلولة",
                de: "Gelöste Fragen",
            },
            correctAnswers: {
                en: "Correct Answers",
                ar: "عدد الاسئلة الصحيحة",
                de: "Richtige Antworten",
            },
            answers: { en: "Answers", ar: "الاجابات", de: "Antworten" },
            answersUnavailable: {
                en: "-- Answers Unavailable --",
                ar: "--الاجابات غير متاحة--",
                de: "-- Antworten nicht verfügbar --",
            },
            viewAnswers: { en: "View Answers", ar: "عرض الاجابات", de: "Antworten anzeigen" },
            homeworkEndTime: {
                en: "Homework End Time",
                ar: "وقت انهاء الواجب",
                de: "Endzeit der Hausaufgabe",
            },
            homeworkStartTime: {
                en: "Homework Start Time",
                ar: "وقت بدأ الواجب",
                de: "Startzeit der Hausaufgabe",
            },
        },
    };

    let columns = [
        {
            name: content.columns.sequence[language],
            reorder: true,
            selector: (row) => row.id,
            sortable: true,
            sortField: "id",
        },
        {
            name: content.columns.homeworkName[language],
            reorder: true,
            selector: (row) => (row.exam ? row.exam.name : ""),
            sortable: true,
            sortField: "exam_id",
        },
        {
            name: content.columns.questionCount[language],
            reorder: true,
            selector: (row) => row.questions_quantity,
            sortable: true,
            sortField: "questions_quantity",
        },
        {
            name: content.columns.result[language],
            reorder: true,
            selector: (row) => `${Math.round((row.result / row.full_result) * 100)} %`,
            sortable: true,
            sortField: "result",
        },
        {
            name: content.columns.grade[language],
            reorder: true,
            selector: (row) => `${row.result} / ${row.full_result}`,
            sortable: true,
            sortField: "result",
        },
        {
            name: content.columns.solvedQuestions[language],
            reorder: true,
            selector: (row) => row.is_selected_count,
            sortable: true,
            sortField: "is_selected_count",
        },
        {
            name: content.columns.correctAnswers[language],
            reorder: true,
            selector: (row) => row.is_correct_answers_count,
            sortable: true,
            sortField: "is_correct_answers_count",
        },
        {
            name: content.columns.answers[language],
            reorder: true,
            selector: (row) => (
                <>
                    {row.exam.show_results ? (
                        <Button
                            className="block px-1 py-1 text-center"
                            element="Link"
                            to={`../exam_results/${row.id}`}
                        >
                            {content.columns.viewAnswers[language]}
                        </Button>
                    ) : (
                        <span className="text-rose-500">
                            {content.columns.answersUnavailable[language]}
                        </span>
                    )}
                </>
            ),
        },
        {
            name: content.columns.homeworkEndTime[language],
            reorder: true,
            selector: (row) => printFullDate(row.updated_at, language),
            sortable: true,
            sortField: "updated_at",
        },
        {
            name: content.columns.homeworkStartTime[language],
            reorder: true,
            selector: (row) => printFullDate(row.created_at, language),
            sortable: true,
            sortField: "created_at",
        },
    ];

    return (
        <div>
            <div className="w-full">
                <RemoteTable
                    isAdmin={false}
                    api={`/api/user/exam_results/hm/paginate`}
                    columns={columns}
                />
            </div>
        </div>
    );
};

export default HmResults;
